import { ChangeDetectionStrategy, Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { ChipControlGroupComponent } from '@libs/form/components';
import { InputItemModel } from '@libs/form/models';
import {
  CatalogSearchFilterSortFormModel,
  CatalogSearchFilterSortValueModel,
  CatalogSearchResultFilterModel,
  CatalogSearchResultSortModel,
} from '@libs/shop/models';

@Component({
  selector: 'ui-catalog-search-filter-sort',
  imports: [
    ChipControlGroupComponent,
  ],
  templateUrl: './catalog-search-filter-sort.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogSearchFilterSortComponent {
  public filterConfig: InputSignal<CatalogSearchResultFilterModel> = input.required();
  public sortConfig: InputSignal<CatalogSearchResultSortModel> = input.required();

  public valueChange: OutputEmitterRef<CatalogSearchFilterSortValueModel> = output();

  public inputItems: Signal<InputItemModel[]> = computed(() => this.mapInputItems(this.filterConfig(), this.sortConfig()));

  public handleValueChange(value: unknown): void {
    const parsedValue: CatalogSearchFilterSortFormModel = value as CatalogSearchFilterSortFormModel;

    const result: CatalogSearchFilterSortValueModel = {
      sort: parsedValue.sort,
      labelFilterValue: this.computeCheckboxFieldValue(parsedValue.labels),
      manufacturerFilterValue: this.computeCheckboxFieldValue(parsedValue.manufacturer),
      ownBrandFilterValue: !parsedValue.ownBrand.length ? undefined : parsedValue.ownBrand,
    };

    this.valueChange.emit(result);
  }

  private computeCheckboxFieldValue(value: Record<string, boolean> | null): string[] {
    if (value === null) {
      return [];
    }

    const returnValue: string[] = [];

    for (const key of Object.keys(value)) {
      if (value[key]) {
        returnValue.push(key);
      }
    }

    return returnValue;
  }

  private mapInputItems(filterConfig: CatalogSearchResultFilterModel, sortConfig: CatalogSearchResultSortModel): InputItemModel[] {
    return [
      {
        type: 'radioButtons',
        name: 'sort',
        label: 'Sortieroptionen',
        defaultValue: 'relevance',
        value: sortConfig.currentActiveSort,
        options: sortConfig.sortOptions,
      },
      {
        type: 'checkboxes',
        name: 'labels',
        label: filterConfig.labelFilterLabel,
        defaultValue: null,
        options: filterConfig.labelFilterOptions,
        value: filterConfig.currentLabelFilterValue,
        attributes: {
          disabled: !filterConfig.labelFilterOptions.length,
        },
      },
      {
        type: 'checkboxes',
        name: 'manufacturer',
        label: filterConfig.manufacturerFilterLabel,
        defaultValue: null,
        value: filterConfig.currentManufacturerFilterValue,
        options: filterConfig.manufacturerFilterOptions,
        attributes: {
          disabled: !filterConfig.manufacturerFilterOptions.length,
        },
      },
      {
        type: 'radioButtons',
        name: 'ownBrand',
        label: filterConfig.ownBrandFilterLabel,
        attributes: {
          disabled: !filterConfig.ownBrandFilterEnabled,
        },
        defaultValue: '',
        value: filterConfig.currentOwnBrandFilterValue ?? '',
        options: [
          {
            value: '',
            label: 'Alle Marken',
          },
          {
            value: 'yes',
            label: 'nur Eigenmarken',
          },
        ],
      },
    ];
  }
}
